import { ArticleModel } from './article.model';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
export class CostCenterPriceModel {
  costCenterPriceId: number = 0;
  costCenterId: number = 0;
  costCenter: CostCenterModel = new CostCenterModel();
  conceptInvoicingId: number = 0;
  articleId: number = 0;
  article: ArticleModel = new ArticleModel();
  swIsInvoiced: boolean = false;
  swInvoiceUnitM2: boolean = false;
  baseUnitValue: number = 0;
  rateDiscount: number = 0;
  unitValue: number = 0;
  minimumQuantityService: number = 0;
  quantityEspecialInvoicing: number = 1;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
